import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';

const BannerTwo = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        banner_heading
        banner_description
        banner_img {
          publicURL
        }
      }
    }
  `);

  const {
    strapiHomePage: { banner_heading, banner_description, banner_img },
  } = data;

  return (
    <section className='banner-two' id='banner'>
      <span className='banner-two__shape-1'></span>
      <span className='banner-two__shape-2'></span>
      <span className='banner-two__shape-3'></span>
      <span className='banner-two__shape-4'></span>
      <div className='banner-two__moc'>
        <img src={banner_img.publicURL} alt='banner-img' />
      </div>
      <div className='container'>
        <div className='row'>
          <div className='col-xl-6 col-lg-8'>
            <div className='banner-two__content'>
              <h3 className='banner-two__title'>{banner_heading}</h3>
              <p className='banner-two__text'>{banner_description}</p>
              <Link to='/contact' className='banner-two__btn thm-btn '>
                <span>Launch Your Idea!</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BannerTwo;
